import useOverviewPage from './use-overview-page';

const useSlug = (slug) => {
  const overviewPage = useOverviewPage();
  return `${overviewPage.slug}${slug}`;
};

export default useSlug;
